import { settingsReducerHasChanges } from './chunk-IVYE5QJV.mjs';
import { CLEAR_SETTINGS_ERROR, UPDATE_SETTINGS_ERRORS, SET_SETTINGS_ERRORS, RESET_SETTINGS_CHANGES, SET_SELECTED_SETTINGS_LOCATIONS, UPDATE_SETTINGS_CHANGE_DATA_VALUES, RESET_SETTINGS_CHANGE_DATA, SET_SETTINGS_DIFF_OBJECT, SET_SETTINGS_CHANGE_DATA_VALUES, SET_SETTINGS_CHANGE_DATA } from './chunk-DHR2SCPN.mjs';
import { __spreadValues, __spreadProps } from './chunk-T36PI2YV.mjs';
import { produce } from 'immer';

var SETTINGS_CHANGE_DATA_INITIAL_STATE = {
  id: 0,
  mode: "create" /* CREATE */,
  settingsSelected: null,
  data: null,
  originalData: null,
  hasChanges: false,
  sectionId: "all",
  differences: [],
  finalDiffObject: null,
  errors: {},
  settingsVersion: 0,
  selectedLocations: []
};
var settingsChangeDataReducer = produce((state = SETTINGS_CHANGE_DATA_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SETTINGS_CHANGE_DATA:
      return action.payload;
    case SET_SETTINGS_CHANGE_DATA_VALUES:
      state.data = action.payload.data;
      state.sectionId = action.payload.sectionId;
      state.hasChanges = settingsReducerHasChanges(state, action.payload.data);
      break;
    case SET_SETTINGS_DIFF_OBJECT:
      state.finalDiffObject = action.payload;
      break;
    case RESET_SETTINGS_CHANGE_DATA:
      return SETTINGS_CHANGE_DATA_INITIAL_STATE;
    case UPDATE_SETTINGS_CHANGE_DATA_VALUES:
      return __spreadValues(__spreadValues({}, state), action.payload);
    case SET_SELECTED_SETTINGS_LOCATIONS:
      state.selectedLocations = action.payload;
      break;
    case RESET_SETTINGS_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        errors: {},
        differences: [],
        hasChanges: false,
        data: action.payload,
        originalData: action.payload,
        sectionId: "all" /* ALL */
      });
    case SET_SETTINGS_ERRORS:
      state.errors = action.payload;
      break;
    case UPDATE_SETTINGS_ERRORS:
      state.errors = __spreadValues(__spreadValues({}, state.errors), action.payload);
      break;
    case CLEAR_SETTINGS_ERROR:
      delete state.errors[action.payload];
      break;
    default:
      return state;
  }
});
var reducer_default = settingsChangeDataReducer;

export { SETTINGS_CHANGE_DATA_INITIAL_STATE, reducer_default };
